export const OPORTUNIDAD_GANADA = 11;
export const OPORTUNIDAD_PERDIDA = 12;